import { Map, fromJS } from 'immutable';

export function request(state, { sportId, data }) {
    return state.set('create', Map({
        state: 'IN_PROGRESS',
        sportId,
        data
    }));
}

export function error(state, { sportId, errors }) {
    return state.set('create', Map({
        state: 'ERROR',
        sportId,
        errors: fromJS(errors)
    }));
}

export function finish(state, { sportId, data }) {
    state = state
        .set('create', Map({
            state: 'IN_PROGRESS',
            sportId,
            data
        }))
        .setIn([ 'items', data.id ], fromJS(data));

    if (state.getIn([ 'collections', sportId ])) {
        state = state.setIn(
            [ 'collections', sportId, 'items' ],
            state.getIn([ 'collections', sportId, 'items' ]).push(data.id)
        );
    }

    return state;
}
